import React from "react";
import { makeStyles } from "@material-ui/core";

import { Copyright } from "../Copyright";
import { TopBar } from "../TopBar";
import { FooterLinks } from "../FooterLinks";

const useStyles = makeStyles((theme) => ({
    main: {
        padding: "0 48px",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        minHeight: "100vh",
        flexGrow: 1,
        background: theme.palette.background.default,
        overflowX: "hidden",
        "@media (max-width: 768px)": {
            padding: "56px 16px 0",  // top padding accounts for the fixed hamburger button
        },
        "@media (min-width: 769px) and (max-width: 1024px)": {
            padding: "0 24px",
        },
    },
}));

export const PageBody = ({ children }: { children?: any }) => {
    const classes = useStyles();
    return (
        <main className={classes.main}>
            <TopBar />
            <div>
                {children}
            </div>
            <div style={{ flexGrow: 1 }} />
            <div style={{ alignSelf: "center" }}>
                <Copyright />
            </div>
            <div style={{ alignSelf: "center" }}>
                <FooterLinks />
            </div>
        </main>
    );
};
